import React, {useState} from 'react';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';

import 'codemirror/mode/xml/xml';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';

import { Controlled as ControlledEditor } from 'react-codemirror2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCompressAlt, faExpandAlt } from '@fortawesome/free-solid-svg-icons';

function Editor(props) {
    const {displayName, language, value, onChange } = props;

    const [open, setOpen] = useState(true)

    function handleChange(editor, data, value ) {
        onChange(value)
    }

    return (
        <div className={`editor__container ${open ? '' : 'collapsed'}`}>
           <div className="editor__title">
               {displayName}
               <button type="button" className="expand__collapse__button" onClick={() => setOpen(prevOpen => !prevOpen)}>
                   <FontAwesomeIcon icon={open ? faCompressAlt : faExpandAlt } />
               </button>
            </div> 
            <ControlledEditor 
                onBeforeChange={handleChange}
                value={value}
                className="code-mirror__wrapper"
                options={{
                    linewrapping: true,
                    lint: true,
                    mode: language,
                    theme: 'material',
                    lineNumbers: true
                }}
            />
      </div>
    ); 
}
export default Editor
